<template>
  <template v-if="!token">
    <div
      @click="handleToLogin"
      class="flex h-32 cursor-pointer items-center space-x-5 rounded-full bg-white px-20 text-base text-primary"
    >
      <span>登录</span>
      <span class="iconfont icon-profile" style="font-size: 18px"></span>
    </div>
  </template>

  <div v-else class="flex items-center space-x-10 text-sm">
    <NuxtLink
      to="/note-create-start"
      class="flex h-32 items-center space-x-5 rounded-full bg-white px-10 text-black-3 transition-all hover:bg-[#FEF4E5] hover:text-primary"
    >
      <span>写游记</span>
      <span class="iconfont icon-edit-square" />
    </NuxtLink>
    <el-popover placement="bottom" trigger="hover" hide-on-click>
      <template #reference>
        <div
          class="flex h-32 cursor-pointer items-center space-x-5 rounded-full bg-white pl-4 pr-10 text-sm text-black-3 transition-all hover:bg-[#FEF4E5] hover:text-primary"
        >
          <img
            :src="userInfo.headImageUrl || defaultAvatar"
            class="h-26 w-26 rounded-full border border-[#efefef]"
          />
          <span class="max-w-120 truncate">{{ userInfo.showName }}</span>
          <span class="iconfont icon-caret-down"></span>
        </div>
      </template>
      <div class="">
        <el-menu
          mode="vertical"
          unique-opened
          class="el-menu-vertical-demo"
          active-text-color="#FD9A00"
          style="
            --el-menu-item-height: 30px;
            --el-menu-sub-item-height: 30px;
            --el-menu-item-font-size: 12px;
            --el-menu-text-color: #333;
            --el-menu-active-color: #fd9a00;
          "
        >
          <el-sub-menu index="1">
            <template #title>
              <span class="iconfont icon-cart mr-6"></span>
              <span>我的订单</span>
            </template>
            <el-menu-item index="1-1">
              <NuxtLink to="/profile/travel-orders">旅游订单</NuxtLink>
            </el-menu-item>
            <el-menu-item index="1-2">
              <NuxtLink to="/profile/car-orders">包车订单</NuxtLink>
            </el-menu-item>
            <el-menu-item index="1-3">
              <NuxtLink to="/profile/visa-orders">签证订单</NuxtLink>
            </el-menu-item>
            <!--            <el-menu-item index="1-4">
              <NuxtLink to="/profile/my-comment">我的评论</NuxtLink>
            </el-menu-item>-->
            <!-- <el-menu-item index="1-4">
              <NuxtLink to="/profile/labour-orders">劳务投递</NuxtLink>
            </el-menu-item> -->
          </el-sub-menu>
          <el-menu-item>
            <span class="iconfont icon-edit-1 mr-6"></span>
            <NuxtLink to="/profile/notes">我的游记</NuxtLink>
          </el-menu-item>
          <el-menu-item>
            <span class="iconfont icon-star mr-6"></span>
            <NuxtLink to="/profile/collection">我的收藏</NuxtLink>
          </el-menu-item>
          <el-menu-item>
            <span class="iconfont icon-chat-message mr-6"></span>
            <NuxtLink to="/chat">我的消息</NuxtLink>
          </el-menu-item>
          <el-menu-item>
            <span class="iconfont icon-logout mr-6"></span>
            <span @click="handleLogout">退出登录</span>
          </el-menu-item>
        </el-menu>
      </div>

      <!-- <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item>
            <NuxtLink to="/profile/userinfo">个人信息</NuxtLink>
          </el-dropdown-item>
          <el-dropdown-item>
            <NuxtLink to="/profile/travel-orders">旅游订单</NuxtLink>
          </el-dropdown-item>
          <el-dropdown-item>
            <NuxtLink to="/profile/car-orders">包车订单</NuxtLink>
          </el-dropdown-item>
          <el-dropdown-item>
            <NuxtLink to="/profile/labour-orders">劳务投递</NuxtLink>
          </el-dropdown-item>
          <el-dropdown-item>
            <NuxtLink to="/profile/notes">我的游记</NuxtLink>
          </el-dropdown-item>
          <el-dropdown-item>
            <NuxtLink to="/profile/collection">我的收藏</NuxtLink>
          </el-dropdown-item>
          <el-dropdown-item>
            <span @click="handleLogout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template> -->
    </el-popover>
  </div>
</template>

<script setup>
import defaultAvatar from '~/assets/img/default_avatar.png'

const authStore = useAuthStore()
const { token } = storeToRefs(authStore)

const userInfoStore = useUserInfoStore()
const { userInfo } = storeToRefs(userInfoStore)

const chatStore = useChatStore()

const route = useRoute()
async function handleToLogin() {
  await navigateTo({
    path: '/login',
    query: {
      redirect: route.path,
      ...route.query
    },
    replace: true
  })
}

watch(
  token,
  () => {
    if (token.value) {
      userInfoStore.getUserInfo()
    }
  },
  { immediate: true }
)

async function handleLogout() {
  try {
    request('/website/web/doLogout', { method: 'post' })
  } finally {
    authStore.cleanToken()
    navigateTo('/')
  }
  // 关闭socket连接
  chatStore.close();
}
</script>

<style lang="scss" scoped>
:deep(.el-menu) {
  border-right: none;
}
:deep(.el-menu-item:hover),
:deep(.el-sub-menu__title:hover) {
  color: #fd9a00;
}
</style>
